import React, {Component, useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Navigate, Outlet, Route, useLocation, useNavigate, useParams} from 'react-router-dom';
import App from 'www/containers/App';
import TermConditions from 'www/components/TermConditions';
import {getOrganizationFromLocation} from 'common/util/common-helpers';
import Header from 'www/containers/Header';
import Footer from 'www/components/Footer';
import {isLoggedIn, showLogin, logout, checkEmail, close, login, validateCsrf} from 'common/login/loginActions';
import {getSettings} from 'www/actions/settingsActions';
import {loadBanners} from 'www/actions/bannerAction';
import {redirectToHome, checkTC, createTCCookie,} from 'www/util/tc-helpers';

const ShowTermConditions = (props) => {
    const acceptTCFunc = () => {
        createTCCookie();
        setTcStatus(true);
    }
    const [tcStatus, setTcStatus] = useState(false);
    const location = useLocation();
    const params = useParams();
    const {path, loginState, validateCsrf, settings, needTC = true, ...rest} = props;
    const {pathname} = location.state.pathname;
    const {search} = location.state.search;
    const showTC = !checkTC();
    const forward = (search === undefined)  ? `${pathname}` : `${pathname}${search}`;

    let pageContent;
    if (showTC) {
        pageContent =
            <div id="app" className={getOrganizationFromLocation()}>
                <Header {...props} params={params}/>
                {!loginState.loginVisible &&
                    <TermConditions {...props} settings={settings} acceptTerms={acceptTCFunc} cancel={redirectToHome}
                                    onLogin={validateCsrf}/>}
                <Footer params={params}/>
            </div>
    } else {
        pageContent = <Navigate to={{pathname} } replace = {true}  state={{ pathname : {pathname} , search : {search} , location : {location}} }/>
    }
    return (
        <>
          <App/>
          {pageContent}
        </>
    )
}

export default connect(
    ({login, settings, globalBanners}) => ({loginState: login, settings, globalBanners}),
    {getSettings, showLogin, login, isLoggedIn, validateCsrf, loadBanners}
)(ShowTermConditions)

